import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { alphabetOnly, alphaNumericHyphenSlash, alphaNumericOnly, alphaNumericWithSpacesSlaceHyphenComma, numericOnly } from 'src/app/functions/validation-functions';
import { DistributorDetails, DocumentDetails } from 'src/app/models/Distributor';
import { InsuranceProductsPlan, InsuranceStatusModel } from 'src/app/models/InsuranceDetailsModel';
import { Item } from 'src/app/models/item';
import { AutoCompleteItem } from 'src/app/models/SelectItems';
import { AdminService } from 'src/app/services/admin.service';
import { GeneralService } from 'src/app/services/general.service';
import { LookUpService } from 'src/app/services/lookup.service';
import swal from 'sweetalert2';

@Component({
  selector: 'app-insurance-provider-edit',
  templateUrl: './insurance-provider-edit.component.html',
  styleUrls: ['./insurance-provider-edit.component.css']
})
export class InsuranceProviderEditComponent {
  activeTab:number=1;
  insuranceForm: FormGroup;
  insuranceStatus: InsuranceStatusModel[] = [];
  submittedInsForm : boolean = false;
  doSwitch:boolean=false;
  menuId:number = 0;
  menuUrl : string = "";
  canEdit : boolean = false;
   id:number = 0;
  planConfigurationConfirmationModalShow : boolean = false;
  planConfigurationComment:string = "";
  planConfigurationCommentFormSubmitted:boolean = false;

  carInsuranceProductsPlanList :Item[] = [];
  bikeInsuranceProductsPlanList :Item[] = [];
  CommInsuranceProductsPlanList :Item[] = [];
  healthIndInsuranceProductsPlanList :Item[] = [];
  healthFamilyInsuranceProductsPlanList :Item[] = [];
  travelInsuranceProductsPlanList :Item[] = [];
  homeInsuranceProductsPlanList :Item[] = [];
  officeInsuranceProductsPlanList :Item[] = [];
  shopInsuranceProductsPlanList :Item[] = [];

  carInsuranceProductsPlan :number[] = [];
  bikeInsuranceProductsPlan :number[] = [];
  CommInsuranceProductsPlan :number[] = [];
  healthIndInsuranceProductsPlan :number[] = [];
  healthFamilyInsuranceProductsPlan :number[] = [];
  travelInsuranceProductsPlan :number[] = [];
  homeInsuranceProductsPlan :number[] = [];
  officeInsuranceProductsPlan :number[] = [];
  shopInsuranceProductsPlan :number[] = [];
  insuranceCompanyConfirmationModalShow : boolean = false;
  insuranceCompanyComment:string = "";
  insuranceCompanyCommentFormSubmitted:boolean = false;
  constructor(private fb: FormBuilder, private _lookupService: LookUpService,private adminService: AdminService,private router:Router
    ,private activatedRoute:ActivatedRoute,private generalService: GeneralService) {
      let obj = this.router.getCurrentNavigation()?.extras?.state;
      if(obj)
      {
        this.menuId = parseInt(obj['menuId'])??0;
        this.menuUrl = obj['menuUrl'];
        this.canEdit = obj['canEdit'];
        this.id = parseInt(obj['id']);
        if(this.canEdit){
          this.getFormData();
        }
      }
      this.insuranceForm = this.fb.group({
        "insuranceId": [''],
        "insuranceName": ['', [Validators.required]],
        "contactNumber": ['', [Validators.required, Validators.pattern('[0-9]{10}')]],
        "whatsAppNumber": ['', Validators.pattern('[0-9]{10}')],
        "email": ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
        "address": ['', [Validators.required]],
        "insuranceStatus": [''],
        "createdDate":['']
      });

  }
  ngOnInit(): void {
  }

  toggleChanged(data:any){
    data.data.comment = data.comment;
    data.data.status = data.status;
    this.InsuranceProductStatusUpdate(data.data);
  }

  get insuranceFormControl() {
    return this.insuranceForm.controls;
  }

  async InsuranceProductStatusUpdate(data:any)
  {
      const res = await this.adminService.InsuranceProductStatusUpdate(data);    
      if (res != null && res.result) {
        swal.fire({
          position: 'center',
          icon: res.result.code == 1 ? 'success' : 'error',
          title: res.result.message,
          showConfirmButton: false,
          timer: 3000,
        });

        if(res.result.code == 1){
          //this.homeBtClick();
        }
      }    
      else
      {
        swal.fire({
          position: 'center',
          icon: 'error',
          title: res.result.message,
          showConfirmButton: false,
          timer: 3000,
        });
      } 
  }

  numberOnly(event:any): boolean {    
    return numericOnly(event);
  }

  alphabetOnly(event:any): boolean {
    return alphabetOnly(event);
  }

  alphaNumericOnly(event:any): boolean {
    return alphaNumericOnly(event);
  }

  alphaNumericWithSpacesSlaceHyphenComma(event:any): boolean {
    return alphaNumericWithSpacesSlaceHyphenComma(event);
  }

  async getFormData()
  {
    const res = await this.adminService.GetInsuranceDetails(this.id); 
      if (res != null && res.result) {
        this.insuranceForm.patchValue(res.result.insuranceDetailsModel);
        this.insuranceStatus = res.result.insuranceStatusList;
        if(res.result.insuranceProductsPlan?.length > 0){
          const plans = res.result.insuranceProductsPlan;
          this.insuranceStatus.forEach((element:InsuranceStatusModel) => {
            element.insuranceProductsPlanListItemObj = plans.filter((p:InsuranceProductsPlan) => p.productId == element.productId).map((m:InsuranceProductsPlan)=> {return {name:m.planDescription, id:m.planID,checked:m.planStatus}});
            switch(element.productId){
              case 1 : this.carInsuranceProductsPlanList = element.insuranceProductsPlanListItemObj ??[]; break;
              case 2 : this.bikeInsuranceProductsPlanList = element.insuranceProductsPlanListItemObj ??[]; break;
              case 3 : this.CommInsuranceProductsPlanList = element.insuranceProductsPlanListItemObj ??[]; break;
              case 4 : this.healthIndInsuranceProductsPlanList = element.insuranceProductsPlanListItemObj ??[]; break;
              case 5 : this.healthFamilyInsuranceProductsPlanList = element.insuranceProductsPlanListItemObj ??[]; break;
              case 6 : this.travelInsuranceProductsPlanList = element.insuranceProductsPlanListItemObj ??[]; break;
              case 7 : this.homeInsuranceProductsPlanList = element.insuranceProductsPlanListItemObj ??[]; break;
              case 8 : this.officeInsuranceProductsPlanList = element.insuranceProductsPlanListItemObj ??[]; break;
              case 9 : this.shopInsuranceProductsPlanList = element.insuranceProductsPlanListItemObj ??[]; break;
            }
          });
        }
      }    
      else
      {
        // swal.fire({
        //   position: 'center',
        //   icon: 'error',
        //   title: 'Something went wrong',
        //   showConfirmButton: false,
        //   timer: 3000,
        // });
      } 
  }

  getSubTitleContent(status:boolean,productName:string){
    return "Are you sure you want to "+ (status == true ? "stop" : "start") +" showing quotes of "+productName.toLocaleLowerCase()+" to the customer?";
  }

  homeBtClick(){
    this.router.navigateByUrl(this.menuUrl,{ state: { menuId:this.menuId, menuUrl : this.menuUrl }});
  }

  onInsuranceCopanyPlanSelect(data:Item[], productId:number){
    let selectedIds = data.map((m:Item)=>{return m.id});
    switch(productId){
      case 1 : this.carInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
      case 2 : this.bikeInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
      case 3 : this.CommInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
      case 4 : this.healthIndInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
      case 5 : this.healthFamilyInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
      case 6 : this.travelInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
      case 7 : this.homeInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
      case 8 : this.officeInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
      case 9 : this.shopInsuranceProductsPlanList?.forEach((element:Item)=>{ element.checked = selectedIds?.includes(element.id) ? true : false; }); break;
    }
  }

  async updatePlanConfiguration()
  {
    if(this.planConfigurationComment??"" != ""){    
      const ids = this.carInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}).concat(
        this.bikeInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}), 
        this.CommInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}),
        this.healthIndInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}),
        this.healthFamilyInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}),
        this.travelInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}),
        this.homeInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}),
        this.officeInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")}),
        this.shopInsuranceProductsPlanList?.filter((f:Item) => f.checked).map((m:Item)=> {return parseInt(m.id??"0")})
      ).join(',');;

      let obj ={
        comment : this.planConfigurationComment,
        insuranceId: parseInt(this.insuranceFormControl['insuranceId'].value??"0"),
        Ids : ids
      };

      //alert(JSON.stringify(obj));
      const res = await this.adminService.updatePlanConfiguration(obj);    
      if (res != null && res.result) {
        swal.fire({
          position: 'center',
          icon: res.result.code == 1 ? 'success' : 'error',
          title: res.result.message,
          showConfirmButton: false,
          timer: 3000,
        });

        if(res.result.code == 1){
          this.planConfigurationConfirmationModalShow = false;
        }
      }    
      else
      {
        swal.fire({
          position: 'center',
          icon: 'error',
          title: res.result.message,
          showConfirmButton: false,
          timer: 3000,
        });
      } 
    }
  }

  async updateInsuracneCompanyStatus(){
    if(this.insuranceCompanyComment??"" != ""){
      let obj ={
        comment : this.insuranceCompanyComment,
        insuranceId: parseInt(this.insuranceFormControl['insuranceId'].value??"0"),
        status : (!this.insuranceFormControl['insuranceStatus'].value)
      };
      const res = await this.adminService.UpdateInsuranceCompanyStatus(obj);    
      if (res != null && res.result) {
        swal.fire({
          position: 'center',
          icon: res.result.code == 1 ? 'success' : 'error',
          title: res.result.message,
          showConfirmButton: false,
          timer: 3000,
        });

        if(res.result.code == 1){
          this.insuranceCompanyConfirmationModalShow = false;
          this.insuranceCompanyComment = "";
          this.getFormData();
        }
      }    
      else
      {
        swal.fire({
          position: 'center',
          icon: 'error',
          title: res.result.message,
          showConfirmButton: false,
          timer: 3000,
        });
      } 
    }
  }

  async saveProviderDetails()
  {
    this.submittedInsForm = true;
    if(this.insuranceForm.valid){
      const res = await this.adminService.SaveInsuranceProviderDetails(this.insuranceForm.value);    
      if (res != null && res.result) {
        swal.fire({
          position: 'center',
          icon: res.result.code == 1 ? 'success' : 'error',
          title: res.result.message,
          showConfirmButton: false,
          timer: 3000,
        });

        if(res.result.code == 1){
          //this.homeBtClick();
        }
      }    
      else
      {
        swal.fire({
          position: 'center',
          icon: 'error',
          title: res.result.message,
          showConfirmButton: false,
          timer: 3000,
        });
      } 
    }
  }
}
